module.exports = __webpack_public_path__ + "img/clogo.35e9dcc3.png";